const FileUploadData = (data) => ({
  documents: data?.Documents ?? [],
})

export default FileUploadData
